import { createInlineNestedAppAuthBridge } from './inlineNestedAppAuthBridge';
import { isHosted } from 'owa-config';
import isNestedAppAuthAvailable from '../isNestedAppAuthAvailable';

export function initializeInlineNestedAppAuthBridge(): void {
    if (!isHosted() && isNestedAppAuthAvailable()) {
        createInlineNestedAppAuthBridge();
    }
}
